module.exports = __webpack_public_path__ + "img/744.acf45d95.jpg";